// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"979eed19","314":"b8e4dab6","453":"1a66ee2f","455":"b0cb4e72","762":"a6779ff2","977":"f45bbcc7"}[chunkId] + ".chunk.js";
};